import { render, staticRenderFns } from "./ReferralLink.vue?vue&type=template&id=d70f10b6"
import script from "./ReferralLink.vue?vue&type=script&lang=js"
export * from "./ReferralLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports